<div id="print-recall-content" *ngIf="recall">
    <h3 align="center" class="text-center">Patient Recall Chart</h3>
    <div class="spacer">&nbsp;</div>

    <table class="table">
        <tbody>
            <tr>
                <td>
                    <div class="form-group">
                        <label for="">Present Medical Condition</label>
                        <h4 class="text-label">{{recall.presentCondition}}</h4>
                    </div>
                </td>
                <td>
                    <div class="form-group">
                        <label for="">Present Medications</label>
                        <h4 class="text-label">{{recall.presentMedications}}</h4>
                    </div>
                </td>
                <td>
                    <div class="form-group">
                        <label for="">Allergies to Medications</label>
                        <h4 class="text-label">{{recall.presentAllergies}}</h4>
                    </div>
                </td>
            </tr>
            <tr>
                <td colspan="3">
                    <div class="form-group">
                        <label for="">Extraoral Examination</label>
                        <h4 class="text-label">{{recall.extraoralExam}}</h4>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>

    <section *ngIf="hasIntraOralExam" class="intraoral-exam">
        <table class="table">
            <thead>
                <tr>
                    <th colspan="2" class="text-left">
                        <span class="label">Legend: </span>
                        <span class="tooth-status text-uppercase"
                        *ngFor="let stat of (toothStatusSvc.record$ | async)?.data || []; let i = index">
                           <svg height="20" width="20">
                                <circle cx="10" cy="10" r="8" stroke="gray" stroke-width="1" [attr.fill]="stat.color" />
                            </svg>
                            {{stat.name}}
                        </span>
                    </th>
                </tr>
                <tr>
                    <th colspan="2" align="center">STATUS</th>
                </tr>
                <tr>
                    <th align="center">RIGHT</th>
                    <th align="center">LEFT</th>
                </tr>
            </thead>
            <tbody>
                <tr class="vbot">
                    <td align="right">
                        <div class="intraoral-tooth text-center pull-right"
                            *ngFor="let idx of intraOralForm.right_0; let i = index;">
                            <!-- <div class="condition">{{intraOral[idx].legendsStr.join(', ')}}</div> -->
                            <div class="condition">
                                <span [style.color]="tc.cr"
                                    *ngFor="let tc of intraOral[idx].legendsObj">{{tc.cd ? tc.cd : '-'}}</span>
                                <span class="tooth-model-label" *ngIf="getToothModelLabel(intraOral[idx])">{{ getToothModelLabel(intraOral[idx]) }}</span>
                            </div>
                            <div class="tooth-number">{{ idx | toothNumber: recall?.toothNumberingSystem }}</div>
                            <ng-container *ngTemplateOutlet="printToothModel; context: { status: intraOral[idx] }"></ng-container>
                        </div>
                    </td>
                    <td>
                        <div class="intraoral-tooth text-center pull-left"
                            *ngFor="let idx of intraOralForm.left_0; let i = index;">
                            <!-- <div class="condition">{{intraOral[idx].legendsStr.join(', ')}}</div> -->
                            <div class="condition">
                                <span [style.color]="tc.cr"
                                    *ngFor="let tc of intraOral[idx].legendsObj">{{tc.cd}}</span>
                                <span class="tooth-model-label" *ngIf="getToothModelLabel(intraOral[idx])">{{ getToothModelLabel(intraOral[idx]) }}</span>
                            </div>
                            <div class="tooth-number">{{ idx | toothNumber: recall?.toothNumberingSystem }}</div>
                            <ng-container *ngTemplateOutlet="printToothModel; context: { status: intraOral[idx] }"></ng-container>
                        </div>
                    </td>
                </tr>
                <!-- <tr><td colspan="2"> <hr> </td></tr> -->
                <tr class="vbot">
                    <td align="right">
                        <div class="intraoral-tooth text-center pull-right"
                            *ngFor="let idx of intraOralForm.right_1; let i = index;">
                            <!-- <div class="condition">{{intraOral[idx].legendsStr.join(', ')}}</div> -->
                            <div class="condition">
                                <span [style.color]="tc.cr"
                                    *ngFor="let tc of intraOral[idx].legendsObj">{{tc.cd}}</span>
                                <span class="tooth-model-label" *ngIf="getToothModelLabel(intraOral[idx])">{{ getToothModelLabel(intraOral[idx]) }}</span>
                            </div>
                            <div class="tooth-number">{{ idx | toothNumber: recall?.toothNumberingSystem }}</div>
                            <ng-container *ngTemplateOutlet="printToothModel; context: { status: intraOral[idx] }"></ng-container>
                        </div>
                    </td>
                    <td>
                        <div class="intraoral-tooth text-center pull-left"
                            *ngFor="let idx of intraOralForm.left_1; let i = index;">
                            <div class="condition">
                                <span [style.color]="tc.cr"
                                    *ngFor="let tc of intraOral[idx].legendsObj">{{tc.cd}}</span>
                                <span class="tooth-model-label" *ngIf="getToothModelLabel(intraOral[idx])">{{ getToothModelLabel(intraOral[idx]) }}</span>
                            </div>
                            <!-- <div class="condition">{{intraOral[idx].legendsStr.join(', ')}}</div> -->
                            <div class="tooth-number">{{ idx | toothNumber: recall?.toothNumberingSystem }}</div>
                            <ng-container *ngTemplateOutlet="printToothModel; context: { status: intraOral[idx] }"></ng-container>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td align="right">
                        <div class="intraoral-tooth text-center pull-right"
                            *ngFor="let idx of intraOralForm.right_2; let i = index;">
                            <ng-container *ngTemplateOutlet="printToothModel; context: { status: intraOral[idx] }"></ng-container>
                            <div class="tooth-number">{{ idx | toothNumber: recall?.toothNumberingSystem }}</div>
                            <div class="condition">
                                <span [style.color]="tc.cr"
                                    *ngFor="let tc of intraOral[idx].legendsObj">{{tc.cd}}</span>
                                <span class="tooth-model-label" *ngIf="getToothModelLabel(intraOral[idx])">{{ getToothModelLabel(intraOral[idx]) }}</span>
                            </div>
                            <!-- <div class="condition">{{intraOral[idx].legendsStr.join(', ')}}</div> -->
                        </div>
                    </td>
                    <td>
                        <div class="intraoral-tooth text-center pull-left"
                            *ngFor="let idx of intraOralForm.left_2; let i = index;">
                            <ng-container *ngTemplateOutlet="printToothModel; context: { status: intraOral[idx] }"></ng-container>
                            <div class="tooth-number">{{ idx | toothNumber: recall?.toothNumberingSystem }}</div>
                            <div class="condition">
                                <span [style.color]="tc.cr"
                                    *ngFor="let tc of intraOral[idx].legendsObj">{{tc.cd}}</span>
                                <span class="tooth-model-label" *ngIf="getToothModelLabel(intraOral[idx])">{{ getToothModelLabel(intraOral[idx]) }}</span>
                            </div>
                            <!-- <div class="condition">{{intraOral[idx].legendsStr.join(', ')}}</div> -->
                        </div>
                    </td>
                </tr>
                <tr>
                    <td align="right">
                        <div class="intraoral-tooth text-center pull-right"
                            *ngFor="let idx of intraOralForm.right_3; let i = index;">
                            <ng-container *ngTemplateOutlet="printToothModel; context: { status: intraOral[idx] }"></ng-container>
                            <div class="tooth-number">{{ idx | toothNumber: recall?.toothNumberingSystem }}</div>
                            <div class="condition">
                                <span [style.color]="tc.cr"
                                    *ngFor="let tc of intraOral[idx].legendsObj">{{tc.cd}}</span>
                                <span class="tooth-model-label" *ngIf="getToothModelLabel(intraOral[idx])">{{ getToothModelLabel(intraOral[idx]) }}</span>
                            </div>
                            <!-- <div class="condition">{{intraOral[idx].legendsStr.join(', ')}}</div> -->
                        </div>
                    </td>
                    <td>
                        <div class="intraoral-tooth text-center pull-left"
                            *ngFor="let idx of intraOralForm.left_3; let i = index;">
                            <ng-container *ngTemplateOutlet="printToothModel; context: { status: intraOral[idx] }"></ng-container>
                            <div class="tooth-number">{{ idx | toothNumber: recall?.toothNumberingSystem }}</div>
                            <div class="condition">
                                <span [style.color]="tc.cr"
                                    *ngFor="let tc of intraOral[idx].legendsObj">{{tc.cd}}</span>
                                <span class="tooth-model-label" *ngIf="getToothModelLabel(intraOral[idx])">{{ getToothModelLabel(intraOral[idx]) }}</span>
                            </div>
                            <!-- <div class="condition">{{intraOral[idx].legendsStr.join(', ')}}</div> -->
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="table">
            <tbody>
                <tr>
                    <td *ngIf="formPoat.periodontal.length>0">
                        <h5>Predental Screening</h5>
                        <span class="text-capitalize"> {{formPoat.periodontal.join(', ')}}</span>
                    </td>
                    <td *ngIf="formPoat.occlusion.length>0">
                        <h5>Occlusion</h5>
                        <span class="text-capitalize"> {{formPoat.occlusion.join(', ')}}</span>
                    </td>
                    <td *ngIf="formPoat.appliance.length>0">
                        <h5>Intra-oral Appliance</h5>
                        <span class="text-capitalize"> {{formPoat.appliance.join(', ')}}</span>
                    </td>
                    <td *ngIf="formPoat.tmd.length>0">
                        <h5>TMJ</h5>
                        <span class="text-capitalize"> {{formPoat.tmd.join(', ')}}</span>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="form-group" *ngIf="recall.procedureSummary && recall.procedureSummary!=''">
            <label for="">Recall Summary</label>
            <h4 class="text-label">{{recall.procedureSummary}}</h4>
        </div>

        <div class="form-group legend-texts" *ngIf="legendTexts && legendTexts.length>0">
            <h4 for=""> <strong>Legends:</strong> </h4>
            <div class="legends">
                <div class="legend" *ngFor="let lt of legendTexts">
                    <span class="code">{{lt.c}}</span>
                    <span class="text">{{lt.t}}</span>
                </div>
            </div>
        </div>

    </section>

      <div class="loading-indicator text-center" *ngIf="loading">
        <div class="spinner">
          <h1><i class="fas fa-spinner fa-spin"></i></h1>
        </div>
      </div>

      <div class="images" *ngIf="!loading">
        <div class="img-files" *ngIf="recallFiles && recallFiles.length > 0; else noFileRecall">
          <div *ngFor="let file of recallFiles">
            <div *ngIf="file.filename; else noImage">
                <img class="img-fluid" [src]="file.filename.startsWith('data:') ? file.filename : base_url + '/file?f=' + file.filename"/>
            </div>
            <ng-template #noImage>
              <p>No image set in Recall</p>
            </ng-template>
          </div>
        </div>
        <ng-template #noFileRecall>
          <div *ngIf="(!recallFiles || recallFiles.length === 0)" class="text-center">
            <p>No Recall Files</p>
          </div>
        </ng-template>
      </div>
      <br>

</div>

<ng-template #printToothModel let-status="status">
    <ng-container *ngIf="useToothDisplayModels(); else legacyPrintToothModel">
        <svg class="print-tooth-model" [ngClass]="'model-' + getToothModelKey(status)" width="33" height="38" viewBox="0 0 100 116" aria-hidden="true">
            <path class="print-tooth-model__enamel" d="M50 10 C27 10 15 29 18 54 C20 71 29 84 36 99 C41 110 48 103 50 89 C52 103 59 110 64 99 C71 84 80 71 82 54 C85 29 73 10 50 10Z" />
            <ng-container *ngIf="isToothModelSurfaceCompatible(status)">
                <path class="print-tooth-model__surface" d="M31 34 C40 25 60 25 69 34 L60 47 C53 43 47 43 40 47Z" [attr.fill]="status.top.color" />
                <path class="print-tooth-model__surface" d="M69 34 C76 43 76 62 67 72 L57 61 C61 56 62 51 60 47Z" [attr.fill]="status.rig.color" />
                <path class="print-tooth-model__surface" d="M67 72 C57 80 43 80 33 72 L43 61 C47 65 53 65 57 61Z" [attr.fill]="status.bot.color" />
                <path class="print-tooth-model__surface" d="M31 34 C24 43 24 62 33 72 L43 61 C39 56 38 51 40 47Z" [attr.fill]="status.lef.color" />
                <rect class="print-tooth-model__surface print-tooth-model__surface--center" x="41" y="47" width="18" height="16" rx="5" [attr.fill]="status.cen.color" />
            </ng-container>
            <path class="print-tooth-model__root-groove" d="M37 100 C41 85 45 77 50 77 C56 77 60 86 64 100" />
            <path class="print-tooth-model__highlight" d="M34 25 C44 18 59 18 67 26" />
            <ng-container [ngSwitch]="getToothModelKey(status)">
                <path *ngSwitchCase="'missing'" class="print-tooth-model__x" d="M30 31 L70 77 M70 31 L30 77" />
                <g *ngSwitchCase="'implant'" class="print-tooth-model__implant">
                    <path d="M50 66 L50 103" />
                    <path d="M39 75 L61 75 M40 84 L60 84 M42 93 L58 93" />
                </g>
                <path *ngSwitchCase="'impacted'" class="print-tooth-model__dashed" d="M22 74 C37 61 63 61 78 74" />
                <path *ngSwitchCase="'unerupted'" class="print-tooth-model__gum" d="M20 70 C36 78 65 78 80 70 L80 91 L20 91Z" />
                <path *ngSwitchCase="'root-fragment'" class="print-tooth-model__fragment" d="M38 69 C44 83 46 96 42 108 M58 69 C54 84 56 97 62 108" />
                <circle *ngSwitchCase="'supernumerary'" class="print-tooth-model__extra" cx="73" cy="30" r="8" />
            </ng-container>
        </svg>
    </ng-container>
    <ng-template #legacyPrintToothModel>
        <svg width="33" height="33" viewBox="0 0 200 200">
            <g transform="translate(100,100)" stroke="#000" stroke-width="1">
                <path d="M-30 30-70 70 A99 99 0 0 1-70-70 L-30 -30 A45 45 0 0 0-30 30Z"
                    [attr.fill]="status.lef.color" stroke="black" class="t-left" />
                <path d="M-30 -30-70-70 A99 99 0 0 1 70-70 L30 -30 A45 45 0 0 0 -30-30Z"
                    [attr.fill]="status.top.color" stroke="black" class="t-top" />
                <path d="M30 -30 70-70 A99 99 0 0 1 70 70 L30 30 A45 45 0 0 0 30 -30Z"
                    [attr.fill]="status.rig.color" stroke="black" class="t-right" />
                <path d="M30 30 70 70 A99 99 0 0 1-70 70 L-30 30 A45 45 0 0 0 30 30Z"
                    [attr.fill]="status.bot.color" stroke="black" class="t-bottom" />
                <circle cx="0" cy="0" r="42" stroke="black" [attr.fill]="status.cen.color"
                    class="t-center"></circle>
            </g>
        </svg>
    </ng-template>
</ng-template>
